import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import {Button, Form, Modal} from "react-bootstrap";
import {FormProvider, useForm} from "react-hook-form";
import React, {cloneElement, Fragment, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import IconButton from "../../../common/IconButton";
import EventBus from "../../../../app/eventbus/EventBus";
import billingService from "../../../../services/billingService";
import OrganizationPackageDiscountForm from "../form/OrganizationPackageDiscountForm";
import {getBillingErrorMessage, getBillingErrorStatus} from "../../../../helpers/billing-response";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {
    UPDATE_ORGANIZATION_PACKAGE_DISCOUNT_FAILED,
    UPDATE_ORGANIZATION_PACKAGE_DISCOUNT_SUCCEED
} from "../../../../app/eventbus/billingEvents";

/**
 * Chegirma summasini o'zgartirish modali.
 * API faqat amount'ni yangilaydi — tashkilot va paket o'zgarmaydi.
 */
const UpdateOrganizationPackageDiscountModal = ({discount, packages, children, ...props}) => {
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    const buildDefaultValues = () => ({
        packageCode: discount?.package?.code ?? null,
        amount: discount?.amount ?? '',
    });

    const methods = useForm({defaultValues: buildDefaultValues()});

    const handleShow = () => {
        // Qator yangilangan bo'lishi mumkin — modal ochilganda joriy qiymatlarni tiklaymiz.
        methods.reset(buildDefaultValues());
        setShow(true);
    };
    const handleClose = () => {
        methods.reset(buildDefaultValues());
        setShow(false);
    };

    const onSubmit = (formData) => {
        setIsLoading(true);
        billingService.updateOrganizationPackageDiscount(discount.id, {amount: Number(formData.amount)})
            .then((updated) => {
                EventBus.dispatch(UPDATE_ORGANIZATION_PACKAGE_DISCOUNT_SUCCEED, updated);
                toast.success(t(lang, 'common.toast.success'));
                handleClose();
            })
            .catch((error) => {
                EventBus.dispatch(UPDATE_ORGANIZATION_PACKAGE_DISCOUNT_FAILED, error);

                const status = getBillingErrorStatus(error);
                const message = getBillingErrorMessage(error);

                if (status === 422) {
                    methods.setError('amount', {
                        type: 'server',
                        message: t(lang, 'admin.organization.package_discounts.error.invalid_amount')
                    });
                    toast.error(t(lang, 'admin.organization.package_discounts.error.invalid_amount'));
                } else if (status === 404) {
                    toast.error(t(lang, 'admin.organization.package_discounts.error.not_found'));
                } else {
                    toast.error(message || t(lang, 'common.toast.error'));
                }
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <Fragment>
            {!!children ? cloneElement(children, {...children.props, onClick: handleShow}) : (
                <IconButton variant={'warning'} size={'sm'} onClick={handleShow} icon={'pencil'} {...props}/>
            )}

            <Modal show={show} onHide={handleClose} size={'lg'}>
                <FormProvider {...methods}>
                    <Form onSubmit={methods.handleSubmit(onSubmit)}>
                        <Modal.Header closeButton={true}>
                            <Modal.Title>{t(lang, 'admin.organization.package_discounts.update_modal.title')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <OrganizationPackageDiscountForm isEditing={true} packages={packages}/>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant={'secondary'} type={'button'} onClick={handleClose}>
                                {t(lang, 'common.button.cancel')}
                            </Button>
                            <Button variant={'primary'} type={'submit'} disabled={isLoading}>
                                {isLoading && <FontAwesomeIcon pulse={true} className="me-2" icon="spinner"/>}
                                {t(lang, 'items.common.save')}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </FormProvider>
            </Modal>
        </Fragment>
    );
};

export default UpdateOrganizationPackageDiscountModal;
